import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import type { entityLinkNameSize } from "scmp-app/components/header/features/entity-link";
import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

type ContainerProps = ResponsiveStyledProps & {
  $isMagazineStyle?: boolean;
  $size: entityLinkNameSize;
};

export const Container = styled.div<ContainerProps>`
  align-items: center;

  font-weight: 700;
  font-size: ${props => (props.$size === "large" ? "14px" : "12px")};
  font-family: ${fontRoboto};
  line-height: ${props => (props.$size === "large" ? "16px" : "14px")};
  white-space: nowrap;

  ${responsiveStyles}

  a {
    color: #000000;
  }
`;
